export class FormulaElement {
    Sign: string;
    IdLine: number;
    Description: string;
    private _RowNo: string;
    get RowNo(): string {
        let prefix = '+';
        if (  this.Sign === 'Minus' ) {
            prefix = '-';
        }
        return prefix + this._RowNo;
    }
    set RowNo(rowNo: string) {
        this._RowNo = rowNo;
    }
}
